import { useMemo, useState } from "react";

import { UserEntityModalProps, UserEntityModalType } from "Bands/contexts";
import {
  CreateUserAddressModal,
  DeleteUserAddressModal,
  EditUserAddressModal,
  CreateUserPhoneNumberModal,
  EditUserPhoneNumberModal,
  DeleteUserPhoneNumberModal,
  CreateUserEmergencyContactModal,
  EditUserEmergencyContactModal,
  DeleteUserEmergencyContactModal,
  CreateUserHomeBaseModal,
  EditUserHomeBaseModal,
  DeleteUserHomeBaseModal,
  CreateUserPassportModal,
  EditUserPassportModal,
  DeleteUserPassportModal,
  CreateUserTravelVisaModal,
  EditUserTravelVisaModal,
  DeleteUserTravelVisaModal,
  CreateUserSocialSecurityFormModal,
  EditUserSocialSecurityFormModal,
  DeleteUserSocialSecurityFormModal,
  CreateUserDrivingPermitModal,
  EditUserDrivingPermitModal,
  DeleteUserDrivingPermitModal,
  CreateUserVehicleModal,
  EditUserVehicleModal,
  DeleteUserVehicleModal,
  CreateUserLoyaltyProgram,
  EditUserLoyaltyProgramModal,
  DeleteUserLoyaltyProgramModal,
} from "Bands/containers";

export const useUserEntityModals = () => {
  const [showCreateModal, setShowCreateModal] = useState<UserEntityModalType | null>(null);
  const [showEditModal, setShowEditModal] = useState<UserEntityModalProps | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState<UserEntityModalProps | null>(null);

  const createModal = useMemo(() => {
    const props = {
      handleClose: () => setShowCreateModal(null),
    };

    switch (showCreateModal) {
      case UserEntityModalType.address:
        return <CreateUserAddressModal {...props} />;
      case UserEntityModalType.phoneNumber:
        return <CreateUserPhoneNumberModal {...props} />;
      case UserEntityModalType.emergencyContact:
        return <CreateUserEmergencyContactModal {...props} />;
      case UserEntityModalType.homeBase:
        return <CreateUserHomeBaseModal {...props} />;
      case UserEntityModalType.passport:
        return <CreateUserPassportModal {...props} />;
      case UserEntityModalType.travelVisa:
        return <CreateUserTravelVisaModal {...props} />;
      case UserEntityModalType.socialSecurityForm:
        return <CreateUserSocialSecurityFormModal {...props} />;
      case UserEntityModalType.drivingPermit:
        return <CreateUserDrivingPermitModal {...props} />;
      case UserEntityModalType.vehicle:
        return <CreateUserVehicleModal {...props} />;
      case UserEntityModalType.loyaltyProgram:
        return <CreateUserLoyaltyProgram {...props} />;
      default:
        return null;
    }
  }, [showCreateModal]);

  const editModal = useMemo(() => {
    if (!showEditModal?.id) return null;

    const props = {
      id: showEditModal.id,
      handleClose: () => setShowEditModal(null),
    };

    switch (showEditModal?.type) {
      case UserEntityModalType.address:
        return <EditUserAddressModal {...props} />;
      case UserEntityModalType.phoneNumber:
        return <EditUserPhoneNumberModal {...props} />;
      case UserEntityModalType.emergencyContact:
        return <EditUserEmergencyContactModal {...props} />;
      case UserEntityModalType.homeBase:
        return <EditUserHomeBaseModal {...props} />;
      case UserEntityModalType.passport:
        return <EditUserPassportModal {...props} />;
      case UserEntityModalType.travelVisa:
        return <EditUserTravelVisaModal {...props} />;
      case UserEntityModalType.socialSecurityForm:
        return <EditUserSocialSecurityFormModal {...props} />;
      case UserEntityModalType.drivingPermit:
        return <EditUserDrivingPermitModal {...props} />;
      case UserEntityModalType.vehicle:
        return <EditUserVehicleModal {...props} />;
      case UserEntityModalType.loyaltyProgram:
        return <EditUserLoyaltyProgramModal {...props} />;
      default:
        return null;
    }
  }, [showEditModal]);

  const deleteModal = useMemo(() => {
    if (!showDeleteModal?.id) return null;

    const props = {
      id: showDeleteModal.id,
      handleClose: () => setShowDeleteModal(null),
    };

    switch (showDeleteModal?.type) {
      case UserEntityModalType.address:
        return <DeleteUserAddressModal {...props} />;
      case UserEntityModalType.phoneNumber:
        return <DeleteUserPhoneNumberModal {...props} />;
      case UserEntityModalType.emergencyContact:
        return <DeleteUserEmergencyContactModal {...props} />;
      case UserEntityModalType.homeBase:
        return <DeleteUserHomeBaseModal {...props} />;
      case UserEntityModalType.passport:
        return <DeleteUserPassportModal {...props} />;
      case UserEntityModalType.travelVisa:
        return <DeleteUserTravelVisaModal {...props} />;
      case UserEntityModalType.socialSecurityForm:
        return <DeleteUserSocialSecurityFormModal {...props} />;
      case UserEntityModalType.drivingPermit:
        return <DeleteUserDrivingPermitModal {...props} />;
      case UserEntityModalType.vehicle:
        return <DeleteUserVehicleModal {...props} />;
      case UserEntityModalType.loyaltyProgram:
        return <DeleteUserLoyaltyProgramModal {...props} />;
      default:
        return null;
    }
  }, [showDeleteModal]);

  const modals = useMemo(
    () => (
      <>
        {createModal}
        {editModal}
        {deleteModal}
      </>
    ),
    [createModal, deleteModal, editModal]
  );

  return { setShowCreateModal, setShowEditModal, setShowDeleteModal, modals };
};
